import _, { map, groupBy, get } from 'lodash'
import moment from 'moment'
import axios from 'axios'

import config from '../config'
import request, { mediaManagerRequest } from '../utils/request'
import {
  getSampleImageFromName,
  getAvailableShapesFromFrames,
  splitFramesFromShapes
} from '../utils/helper'

export const fetchProductAttributes = async (productName, frameName) => {
  const targetUri = `${config.backendBaseUrl}/products/${productName}/${frameName}.json`

  const response = await request.get(targetUri, {
    baseURL: null,
    headers: {
      Authorization: 'Bearer' + config.backendAuthorization
    }
  })

  let attributes = get(response, 'data.attributes') || []

  attributes = attributes.map(attribute => ({
    ...attribute,
    options: attribute.options.map((option) => {
      const imageSrc = getSampleImageFromName(option.value, 'attribute')
      option.is_default = option.value === attribute.default_value
      return { ...option, thumbnailUrl: imageSrc }
    })
  }))

  return attributes
}

export const fetchFrameSizes = async (productName) => {
  if (!productName) {
    console.warn('[fetchFrameSizes] No product provided!')

    return []
  }

  const targetUri = `${config.backendBaseUrl}/products/${productName}.json`

  const response = await request.get(targetUri, {
    baseURL: null,
    headers: {
      Authorization: 'Bearer' + config.backendAuthorization
    }
  })

  if (!response.data.frame_sizes && !response.data.name) {
    // TODO: Logging warning...
    return []
  }

  // TODO: Remove this in the production.
  let frames = map(response.data.frame_sizes || {}, (frame) => {
    frame.thumbnailUrl = getSampleImageFromName(frame.name, 'size')

    return frame
  })

  frames = splitFramesFromShapes(frames)

  const shapes = getAvailableShapesFromFrames(frames)

  frames = groupBy(frames, () => 'Print Size')

  const formTitle = get(response, 'data.title')

  return {
    title: formTitle || 'Framed Print',
    frames: map(frames, (frames, name) => ({
      id: 1,
      title: name,
      options: frames
    })),
    shapes
  }
}

export const uploadImages = async (file, options = {}) => {
  // Upload files require pass a FormData object instead.
  const form = new FormData()
  form.append('file', file)

  form.append('user_id', config.userId)

  const response = await request.post('/api/v1/upload', form, {
    'Content-Type': 'multipart/form-data',
    ...options
  })

  return response.data
}

export const cropImages = async (session, data) => {
  const response = await request.patch(`api/v1/sessions/${session}/cropped`, data)
  return response.data
}

export const uploadSignature = async (file, options = {}) => {
  const form = new FormData()
  form.append('file', file)
  form.append('user_id', config.userId)

  const response = await request.post('/api/v1/upload-signrature', form, {
    'Content-Type': 'multipart/form-data',
    ...options
  })

  return response.data
}

export const cropImage = async (session, data) => {
  const response = await request.post(`/api/v1/process/${session}`, data)

  return response.data
}

export const submitOrderForm = async (data) => {
  const targetUri = `/wp-admin/admin-ajax.php?action=${config.atcAjaxAction}`

  const submitOrderRes = await axios.post(targetUri, data)

  return submitOrderRes.data
}

export const createSession = async (productName) => {
  const currentDate = moment().format('YYYY-MM-DD HH:mm:ss')
  const sessionName = `${productName}-${currentDate}`

  const createSessionRes = await mediaManagerRequest.post('/api/session', { name: sessionName })

  return createSessionRes.data
}

export const createBatch = async () => {
  const createSessionRes = await request.post('/api/v1/batch', {
    user_id: config.userId
  })

  return createSessionRes.data
}

export const getBatchByUser = async () => {
  const sessionRes = await request.get('/api/v1/batch/user/' + config.userId)

  return sessionRes.data
}

export const completeBatch = async (batch, data) => {
  const response = await request.patch(`/api/v1/batch/${batch}/complete`, data)

  return response.data
}

export const updateFileAmount = async ({ quantity, uuid }) => {
  const updateQuantityRes = await request.patch(`/api/v1/sessions/${uuid}/quantity`, { quantity })

  return updateQuantityRes.data
}

export const removeFile = async (uuid) => {
  const removeFileRes = await request.delete(`/api/v1/sessions/${uuid}`)

  return removeFileRes.data
}

export const fetchSessionData = async (sessionId) => {
  const fetchSessionDataRes = await mediaManagerRequest.get(`/api/session/${sessionId}`)

  return fetchSessionDataRes.data
}

export const fetchBatchData = async (batch) => {
  if (typeof batch === 'object') {
    batch = batch.key
  }
  const fetchBatchDataRes = await request.get(`/api/v1/batch/${batch}`)

  return fetchBatchDataRes.data
}

export const fetchProductList = async () => {
  const targetUri = `${config.backendBaseUrl}/products.json`

  const fetchProductListRes = await request.get(targetUri, {
    baseURL: null,
    headers: {
      Authorization: 'Bearer' + config.backendAuthorization
    }
  })

  return _.get(fetchProductListRes, 'data.data')
}

export const getProductAPIVersion = async () => {
  const targetUri = `${config.backendBaseUrl}/version`

  const getProductAPIVersionRes = await request.get(targetUri, {
    baseURL: null,
    headers: {
      Authorization: 'Bearer' + config.backendAuthorization
    }
  })

  return _.get(getProductAPIVersionRes, 'data.version')
}

export const getOrderItems = async (orderId) => {
  const targetUri = `/wp-admin/admin-ajax.php?action=get_order_items&order_id=${orderId}`

  const orderItems = await request.get(targetUri, { baseURL: null })

  return orderItems.data
}

export const getItemProductionProgress = async (itemId) => {
  const targetUri = `/wp-admin/admin-ajax.php?action=get_item_progress&item_id=${itemId}`

  const itemProgress = await request.get(targetUri, { baseURL: null })

  return itemProgress.data
}

export const getBoxPrice = async (data) => {
  const targetUri = '/wp-admin/admin-ajax.php?action=bree_get_box_price'

  const response = await request.post(targetUri, data, { baseURL: null })

  return response.data
}
